import { Filter } from '@starryui10/images/icons/Filter';
import { ManagedDropdown } from '@starryui10/ManagedDropdown/ManagedDropdown';
import React from 'react';
import { StyledButton } from '../../../../../.starryUI/grids/cells/HeaderCell/HeaderCell';
import { getColumnFilterQuery } from '../../graphql/useColumnFilter';
import { strings } from '../../localization';
import { getColumnFilterType } from '../../utils/typeUtil';
import { CheckBoxColumnFilter } from './CheckboxColumnFilter';
import { SearchColumnFilter } from './SearchColumnFilter';

export interface IColumnFilterButtonProps {
    display: boolean;
    field: string;
    displayName: string;
    handleOnChange: () => void;
}

export type ColumnFilterType = 'SEARCH' | 'CHECKBOX' | 'NONE';

export const ColumnFilterButton = ({ display, displayName, field }: IColumnFilterButtonProps) => {
    const ColumnFilter = () => {
        const columnFilterType = getColumnFilterType(field);
        switch (columnFilterType) {
            case 'SEARCH':
                return <SearchColumnFilter displayName={displayName} field={field} />;
            case 'CHECKBOX': {
                const columnFilterQuery = getColumnFilterQuery(field);
                if (!columnFilterQuery) {
                    return <></>;
                }
                return (
                    <CheckBoxColumnFilter
                        displayName={displayName}
                        field={field}
                        queryName={columnFilterQuery.queryName}
                        useColumnFilter={columnFilterQuery.useColumnFilter}
                    />
                );
            }
            default:
                return <></>;
        }
    };

    const title = strings.formatString(display ? strings.ColumnFilter_Label_HasFilter : strings.ColumnFilter_Label_NoFilter, displayName).toString();
    return (
        <ManagedDropdown
            width="250px"
            placement="bottom-end"
            manager={(onClick, { visible }) => (
                <StyledButton
                    type="button"
                    aria-label={title}
                    title={title}
                    aria-pressed={visible}
                    aria-expanded={visible}
                    display={display}
                    onClick={onClick}
                >
                    <Filter height="16px" width="16px" />
                </StyledButton>
            )}
        >
            <ColumnFilter />
        </ManagedDropdown>
    );
};
